import { LegacyDevice } from 'console/device/device';
import { DevicePermission } from 'console/device/device_ts';
import { BoilerAdapter, IOExtension } from 'z3k-config';
import { removeNulls } from 'utils';
export function getLatestFirmware(object_type, item, last_firmwares) {
    //@ts-ignore complicated objects
    const { hw, fw, fw_str } = object_type.getHardwareAndSoftwareVersion(item);
    if (hw == -1) {
        return null;
    }
    const latest = last_firmwares[hw];
    if (latest == null) {
        return null;
    }
    if (fw < latest.version ||
        (fw === latest.version && fw_str !== latest.version_str)) {
        return { latest, fw_str, hw };
    }
    return null;
}
export function accessoriesFirmwareUpdate(user_id, last_firmwares, device, only_io_ext_id, only_owner) {
    if (!device) {
        return [];
    }
    if (only_owner && device.user_id != user_id) {
        return [];
    }
    if (!LegacyDevice.has_access(user_id, device, [DevicePermission.update_firmware])) {
        return [];
    }
    if (device.z3k_config == null) {
        return [];
    }
    const io_extensions_for_update = removeNulls([IOExtension, BoilerAdapter].flatMap((object_type) => object_type.get
        //@ts-ignore complicated objects
        .where(device.z3k_config, object_type.canUpdate)
        .map((item) => {
        if (only_io_ext_id) {
            if (only_io_ext_id !== item.id) {
                return null;
            }
        }
        const latest_fw = getLatestFirmware(object_type, item, last_firmwares);
        const serial = typeof item.serial == 'object' && 'value' in item.serial
            ? item.serial.value
            : item.serial;
        if (latest_fw && latest_fw.latest.force_view) {
            const { latest, fw_str, hw } = latest_fw;
            return {
                firmware: latest,
                fw_str,
                hw,
                serial,
                item_id: item.id,
                item_name: item.name,
            };
        }
        return null;
    })));
    return io_extensions_for_update;
}
export function isAccessoriesFirmwareDeclined(device_id, firmware_result, declines) {
    return declines.some((declined) => declined.device_id == device_id &&
        firmware_result.item_id == declined.io_ext_id &&
        declined.id == firmware_result.firmware.id);
}
